const SalesDataColumns = [
  {
    title: 'ERP编号',
    key: 'erpId',
    dataIndex: 'erpId',
    width: 120
  },
  {
    title: '姓名',
    key: 'manageName',
    dataIndex: 'manageName',
    width: 120
  },
  {
    title: '当期待购工单完成数',
    key: 'pendingWorkOrderCnt',
    dataIndex: 'pendingWorkOrderCnt',
    width: 120
  },
  {
    title: '当期待购工单已购数',
    key: 'pendingWorkOrderBuyCnt',
    dataIndex: 'pendingWorkOrderBuyCnt',
    width: 120
  },
  {
    title: '当期待购工单转化率',
    key: 'pendingWorkOrderBuyRate',
    dataIndex: 'pendingWorkOrderBuyRate',
    width: 120,
    customRender: ({ text }) => {
      if (text > 0) {
        return text + '%'
      } else {
        return text
      }
    }
  },
  {
    title: '当期计提销售额（元）',
    key: 'jtSales',
    dataIndex: 'jtSales',
    width: 120
  },
  {
    title: '历史月退款金额（元）',
    key: 'refundSales',
    dataIndex: 'refundSales',
    width: 120
  },
  {
    title: '当期提成金额（元）',
    key: 'jtBonus',
    dataIndex: 'jtBonus',
    width: 120
  },
  {
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    width: 100,
    slots: { customRender: 'action' }
  }
]

const PurchasedColumns = [
  {
    title: '工单ID',
    key: 'workOrderId',
    dataIndex: 'workOrderId'
  },
  {
    title: '处方ID',
    key: 'serialNumber',
    dataIndex: 'serialNumber'
  },
  {
    title: '医生姓名',
    key: 'doctorName',
    dataIndex: 'doctorName'
  },
  {
    title: '患者姓名',
    key: 'patientName',
    dataIndex: 'patientName'
  },
  {
    title: '计提销售额（元）',
    key: 'jtSales',
    dataIndex: 'jtSales',
    width: 180
  },
  {
    title: '提成金额（元）',
    key: 'jtBonus',
    dataIndex: 'jtBonus'
  },
  {
    title: '操作',
    key: 'handle',
    dataIndex: 'handle',
    slots: {
      customRender: 'handle'
    }
  }
]

export { SalesDataColumns, PurchasedColumns }
